import React from 'react';

import './styles.scss';

interface WidgetButtonsProps {
  children?: React.ReactNode | React.ReactNode[];
}

const WidgetButtons: React.FC<WidgetButtonsProps> = ({ children }) => {
  return <div className="widget-buttons-container">{children}</div>;
};

export default WidgetButtons;
